package com.ervasstudio.tracoemovimento.util

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.dom.Div
import org.w3c.dom.HTMLElement

@Composable
fun ApiHtmlRenderer(
    rawHtml: String,
    modifier: Modifier = Modifier
) {
    // 1. Tratamento da String da API
    val htmlLimpo = rawHtml
        .replace("\\\"", "\"")  // Remove escape de aspas
        .replace("\\n", "")     // Remove quebras de linha escapadas
        .replace("\\r", "")
        .replace("&nbsp;", "\u00A0")
        .replace("&nbsp", "\u00A0")
        // Garante que tags <em> vazias recebam um espaço visível para não colapsarem (0px)
        .replace(Regex("<em>\\s*</em>"), "<em>\u00A0</em>")
        .replace(Regex("<p>\\s*</p>"), "<p>\u00A0</p>")

    // 2. Renderização Nativa do HTML via DOM
    Div(
        attrs = modifier.toAttrs {
            // Criamos uma ID ou capturamos a referência ao ser montado
        }
    ) {
        // DisposableEffect monitora mudanças na string 'htmlLimpo'
        DisposableEffect(htmlLimpo) {
            // Procura o elemento HTML pai e injeta o HTML puro
            val element = scopeElement as? HTMLElement
            element?.innerHTML = htmlLimpo

            onDispose { }
        }
    }
}